import { Controller } from "@hotwired/stimulus"

// Puts the chosen slot into the button that will act on it.
//
// THE PANEL HAS A DEFAULT and somebody has to be able to see it. Today's
// dinner is pre-checked, which is the right default — it is where a recipe
// usually goes — but a default nobody notices plans a meal they did not
// pick, and reads as a form accepting an empty answer.
//
// A line of faint text above the submit was the first answer and was missed:
// it sits below the servings block, and it does not change when you choose,
// so it reads as boilerplate. The BUTTON cannot be missed, because it is the
// thing being pressed.
//
// SERVER-RENDERED FIRST. The label ships correct for the default, so the
// button is right before this connects and stays right with JavaScript off —
// this only keeps it in step as the choice changes.
export default class extends Controller {
  static targets = ["label"]

  connect() {
    this.render()
  }

  render() {
    const chosen = this.element.querySelector("input[name='planned_meal[slot]']:checked")
    if (!chosen || !this.hasLabelTarget) return

    // "2026-09-08|dinner" — the value carries both halves because one tap
    // chooses both, which is what makes the grid a grid rather than two
    // questions. See PlannedMealsController#slot_choice.
    const [date, mealType] = chosen.value.split("|")
    this.labelTarget.textContent = `Add to ${this.dayWord(date)} ${mealType}`
  }

  // Today and its neighbours by name, everything else by weekday. The same
  // three words RecipesHelper#relative_day_name uses on the server, because
  // a button that renamed the day the panel just called "Tomorrow" would be
  // two vocabularies for one date.
  dayWord(value) {
    const chosen = new Date(`${value}T00:00:00`)
    const today = new Date()
    today.setHours(0, 0, 0, 0)

    const days = Math.round((chosen - today) / 86400000)
    if (days === 0) return "today's"
    if (days === 1) return "tomorrow's"
    if (days === -1) return "yesterday's"

    return `${chosen.toLocaleDateString(undefined, { weekday: "long" })}'s`
  }
}
